/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusEDocumentDto
 */
export interface NovitusEDocumentDto {
    /**
     * Identyfikator transakcji, potrzebny do zidentyfikowania klienta
     * @type {string}
     * @memberof NovitusEDocumentDto
     */
    transaction_id: string;
    /**
     * Protokół jakim ma zostać wysłany eDokument
     * @type {string}
     * @memberof NovitusEDocumentDto
     */
    protocol?: NovitusEDocumentDtoProtocolEnum;
    /**
     * Tryb wysyłania eDokumentu
     * @type {string}
     * @memberof NovitusEDocumentDto
     */
    print_send_mode?: NovitusEDocumentDtoPrintSendModeEnum;
}


/**
 * @export
 */
export const NovitusEDocumentDtoProtocolEnum = {
    NOVITUS: 'NOVITUS',
    MF: 'MF'
} as const;
export type NovitusEDocumentDtoProtocolEnum = typeof NovitusEDocumentDtoProtocolEnum[keyof typeof NovitusEDocumentDtoProtocolEnum];

/**
 * @export
 */
export const NovitusEDocumentDtoPrintSendModeEnum = {
    print_no_send: 'print_no_send',
    no_print_send_later: 'no_print_send_later',
    print_send_later: 'print_send_later',
    always_print_and_send_later: 'always_print_and_send_later'
} as const;
export type NovitusEDocumentDtoPrintSendModeEnum = typeof NovitusEDocumentDtoPrintSendModeEnum[keyof typeof NovitusEDocumentDtoPrintSendModeEnum];


/**
 * Check if a given object implements the NovitusEDocumentDto interface.
 */
export function instanceOfNovitusEDocumentDto(value: object): value is NovitusEDocumentDto {
    if (!('transaction_id' in value) || value['transaction_id'] === undefined) return false;
    return true;
}

export function NovitusEDocumentDtoFromJSON(json: any): NovitusEDocumentDto {
    return NovitusEDocumentDtoFromJSONTyped(json, false);
}

export function NovitusEDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusEDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transaction_id': json['transaction_id'],
        'protocol': json['protocol'] == null ? undefined : json['protocol'],
        'print_send_mode': json['print_send_mode'] == null ? undefined : json['print_send_mode'],
    };
}

export function NovitusEDocumentDtoToJSON(value?: NovitusEDocumentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'transaction_id': value['transaction_id'],
        'protocol': value['protocol'],
        'print_send_mode': value['print_send_mode'],
    };
}

